import MediaModel from './mediaModel';
import $ from 'jquery';
import _ from 'lodash';
import Backbone from 'backbone';
import {replaceCloudfrontUrl} from '../../sinclair/sinclair.media.utils';
import {Tagging} from '../../sinclair/sinclair.utils';

export const ImageModel = MediaModel.extend({
    urlRoot: '/api/rest/facade/image',
    type: 'image', //backbone model type
    defaults: {
        image: {
            alt: 'alt text here',
            aspectRatio: 1.1,
            attributes: [],
            caption: 'Add Caption Here',
            created: '',
            drm: '',
            externalId: '',
            height: 1,
            large1x1Url: '/resources/media/05da5f27-13eb-468f-905d-7f205c157b9b-Ma6eF1Xr.PNG?1428615795632',
            large16x9Url: '/resources/media/2fa0f41e-cc32-4abd-9aac-e437a0b91838-Ma6eF1Xr.PNG?1428615795123',
            large36x25Url: '/resources/media/bb098814-1b25-4a23-96a0-2a345ef612b7-Ma6eF1Xr.PNG?1428615795314',
            large21x9Url: '/resources/media/bb098814-1b25-4a23-96a0-2a345ef612b7-Ma6eF1Xr.PNG?1428615795314',
            large3x1Url: '/resources/media/bb098814-1b25-4a23-96a0-2a345ef612b7-Ma6eF1Xr.PNG?1428615795314',
            large3x4Url: '/resources/media/bb098814-1b25-4a23-96a0-2a345ef612b7-Ma6eF1Xr.PNG?1428615795314',
            largeBlurUrl: '/resources/media/bb098814-1b25-4a23-96a0-2a345ef612b7-Ma6eF1Xr.PNG?1428615795314',
            largeScaleUrl: '/resources/media/bb098814-1b25-4a23-96a0-2a345ef612b7-Ma6eF1Xr.PNG?1428615795314',
            medium1x1Url: '/resources/media/4a828526-12af-48b8-8c1f-a7bae3a95732-Ma6eF1Xr.PNG?1428615795530',
            medium16x9Url: '/resources/media/efbf30d6-70f5-41f9-8b54-df1f7b193e93-Ma6eF1Xr.PNG?1428615795005',
            medium36x25Url: '/resources/media/f557d7d1-d2bd-43a9-b86f-4fef9a56bab7-Ma6eF1Xr.PNG?1428615795233',
            medium21x9Url: '/resources/media/bb098814-1b25-4a23-96a0-2a345ef612b7-Ma6eF1Xr.PNG?1428615795314',
            medium3x1Url: '/resources/media/bb098814-1b25-4a23-96a0-2a345ef612b7-Ma6eF1Xr.PNG?1428615795314',
            medium3x4Url: '/resources/media/bb098814-1b25-4a23-96a0-2a345ef612b7-Ma6eF1Xr.PNG?1428615795314',
            metadata: '',
            orderNumber: 999,
            original: 'true',
            originalBlurUrl: '/resources/media/1447163b-b889-47b3-8f5d-ee9dbea1da84-Ma6eF1Xr.PNG?1428615794841',
            originalUrl: '/resources/media/1447163b-b889-47b3-8f5d-ee9dbea1da84-Ma6eF1Xr.PNG?1428615794841',
            small1x1Url: '/resources/media/cd401cab-4fbb-40cb-a809-c08fd4ae5a29-Ma6eF1Xr.PNG?1428615795472',
            small16x9Url: '/resources/media/c7a8787a-a42c-4045-be10-61039392239b-Ma6eF1Xr.PNG?1428615794900',
            small36x25Url: '/resources/media/766c01c9-a958-416b-88ee-13e14d78a439-Ma6eF1Xr.PNG?1428615795182',
            small21x9Url: '/resources/media/bb098814-1b25-4a23-96a0-2a345ef612b7-Ma6eF1Xr.PNG?1428615795314',
            small3x1Url: '/resources/media/bb098814-1b25-4a23-96a0-2a345ef612b7-Ma6eF1Xr.PNG?1428615795314',
            small3x4Url: '/resources/media/bb098814-1b25-4a23-96a0-2a345ef612b7-Ma6eF1Xr.PNG?1428615795314',
            smallBlurUrl: '/resources/media/bb098814-1b25-4a23-96a0-2a345ef612b7-Ma6eF1Xr.PNG?1428615795314',
            smallScaleUrl: '/resources/media/bb098814-1b25-4a23-96a0-2a345ef612b7-Ma6eF1Xr.PNG?1428615795314',
            large2x3Url: '/resources/media/bb098814-1b25-4a23-96a0-2a345ef612b7-Ma6eF1Xr.PNG?1428615795314',
            medium2x3Url: '/resources/media/bb098814-1b25-4a23-96a0-2a345ef612b7-Ma6eF1Xr.PNG?1428615795314',
            small2x3Url: '/resources/media/bb098814-1b25-4a23-96a0-2a345ef612b7-Ma6eF1Xr.PNG?1428615795314',
            title: 'Add Title Here',
            type: 'Image',
            updatedBy: 'Sinclair Digital',
            uuid: '',
            version: 1,
            width: 1,
        },
        tags: [],
    },
    tagging: Tagging,
    parse(data) {
        return data?.data?.[0] ?? data;
    },
    save(atts, opts) {
        const that = this;
        const options = opts || {};
        const attrs = atts || this.attributes;

        that.url = this.urlRoot.replace('/' + this.id, '') + (this.id ? '/' + this.id : '');

        return Backbone.Model.prototype.save.call(this, _.pick(attrs, _.keys(this.defaults)), options);
    },
    destroy(options) {
        const opts = _.extend(
            {
                url: this.urlRoot.replace('/' + this.id, '') + (this.id ? '/' + this.id : ''),
            },
            options || {},
        );
        return Backbone.Model.prototype.destroy.call(this, opts);
    },
    initialize() {
        this.tagging.init(this);
        const model = this;
        const attributes = this.attributes.image;
        model.vars = {};
        model.type = 'image';
        model.url = model.urlRoot;
        model.id = this.attributes.image.uuid;
        const renditions = {
            large16x9Url: {
                width: 986,
                height: 555,
                x: 0,
                y: 0,
            },
            large36x25Url: {
                width: 360,
                height: 250,
                x: 0,
                y: 0,
            },
            large1x1Url: {
                width: 360,
                height: 360,
                x: 0,
                y: 0,
            },
            medium16x9Url: {
                width: 648,
                height: 364,
                x: 0,
                y: 0,
            },
            medium36x25Url: {
                width: 144,
                height: 100,
                x: 0,
                y: 0,
            },
            medium1x1Url: {
                width: 200,
                height: 200,
                x: 0,
                y: 0,
            },
            small16x9Url: {
                width: 160,
                height: 90,
                x: 0,
                y: 0,
            },
            small36x25Url: {
                width: 72,
                height: 50,
                x: 0,
                y: 0,
            },
            small1x1Url: {
                width: 90,
                height: 90,
                x: 0,
                y: 0,
            },

            large21x9Url: {width: 1280, height: 548, x: 0, y: 0},
            medium21x9Url: {width: 640, height: 274, x: 0, y: 0},
            small21x9Url: {width: 160, height: 68, x: 0, y: 0},

            large3x1Url: {width: 1280, height: 426, x: 0, y: 0},
            medium3x1Url: {width: 640, height: 274, x: 0, y: 0},
            small3x1Url: {width: 160, height: 53, x: 0, y: 0},

            large3x4Url: {width: 960, height: 427, x: 0, y: 0},
            medium3x4Url: {width: 480, height: 640, x: 0, y: 0},
            small3x4Url: {width: 120, height: 160, x: 0, y: 0},

            jumbo2x3Url: {width: 1280, height: 1920, x: 0, y: 0},
            large2x3Url: {width: 854, height: 1280, x: 0, y: 0},
            medium2x3Url: {width: 427, height: 640, x: 0, y: 0},
            small2x3url: {width: 107, height: 160, x: 0, y: 0},
        };

        let edit = {};
        model.vars.renditions = {};

        $.each(attributes, function(attributesName, value) {
            if (renditions.hasOwnProperty(attributesName)) {
                let json;
                try {
                    json = $.parseJSON(value);
                } catch (e) {
                    json = {
                        id: model.parseUrlForId(value),
                        url: value,
                        width: renditions[attributesName].width,
                        height: renditions[attributesName].height,
                        x: 0,
                        y: 0,
                    };
                }
                model.vars.renditions[attributesName] = json;
                model.vars.renditions[attributesName].editorUrl = replaceCloudfrontUrl(
                    model.attributes.image[attributesName],
                );
                if (json.width * json.r < json.scaleWidth) {
                    model.vars.renditions[attributesName].warn = true;
                } else {
                    model.vars.renditions[attributesName].warn = false;
                }
            } else if (attributesName === 'edit') {
                edit = $.parseJSON(value);
                model.vars[attributesName] = edit;
            } else if (attributesName !== 'originalUrl') {
                model.vars[attributesName] = value;
            }
        });

        if (edit.hasOwnProperty('originalUrl')) {
            model.vars.renditions.originalUrl = {
                url: model.attributes.image.originaUrl,
                id: model.attributes.image.externalId,
                width: edit.originalUrl.width,
                height: edit.originalUrl.height,
                x: edit.originalUrl.x,
                y: edit.originalUrl.y,
                x2: edit.originalUrl.x2,
                y2: edit.originalUrl.y2,
            };
        }
        return model;
    },
    setModelUrl(url) {
        this.rootUrl = url;
    },
    parseUrlForFilename(url) {
        let filename = url.split('/');
        filename = filename[filename.length - 1].split('-');
        filename = filename.slice(5, filename.length).join('-');
        return filename;
    },
    parseUrlForId(url) {
        return url
            ? url
                .split('/')
                .pop()
                .split('-')
                .slice(0, 5)
                .join('-')
            : '';
    },
    getModelPropertyValue(propertyName) {
        const saveUsecase = (obj, propName) => {
            let value;
            $.each(obj.attributes.image.attributes, function() {
                if (this.name === propName) {
                    value = this.value;
                }
            });
            return value;
        };
        const tagsUsecase = obj => {
            return obj.attributes.tags;
        };
        const defaultUsecase = (obj, propName) => {
            return obj.attributes.image[propName];
        };

        const propSwitch = {
            originalUrl: saveUsecase,
            large16x9Url: saveUsecase,
            large36x25Url: saveUsecase,
            large1x1Url: saveUsecase,
            large21x9Url: saveUsecase,
            large3x1Url: saveUsecase,
            large3x4Url: saveUsecase,
            medium16x9Url: saveUsecase,
            medium36x25Url: saveUsecase,
            medium1x1Url: saveUsecase,
            medium21x9Url: saveUsecase,
            medium3x1Url: saveUsecase,
            medium3x4Url: saveUsecase,
            small16x9Url: saveUsecase,
            small36x25Url: saveUsecase,
            small1x1Url: saveUsecase,
            small21x9Url: saveUsecase,
            small3x1Url: saveUsecase,
            small3x4Url: saveUsecase,
            jumbo2x3Url: saveUsecase,
            large2x3Url: saveUsecase,
            medium2x3Url: saveUsecase,
            small2x3Url: saveUsecase,
            canvas: saveUsecase,
            edit: saveUsecase,
            save: saveUsecase,
            tags: tagsUsecase,
        };
        return (propSwitch[propertyName] ? propSwitch[propertyName] : defaultUsecase)(this, propertyName);
    },
    /*
     * set property values because they are in the "video" wrapper
     * can be a pair of strings or a JSON object in the "propertyValue" slot
     */
    // TODO: This methods and all the tagging methods look like dead code. - ADM 1.12.2017
    setModelPropertyValue(propertyValue, propertyName) {
        const that = this;
        const attributes = this.attributes.image.attributes;
        let attributeFound = false;

        function setValue(_propertyValue, _propertyName) {
            const saveUsecase = (propValue, propName) => {
                for (const key in attributes) {
                    if (attributes[key].name === propName) {
                        attributeFound = true;
                        attributes[key].value = propValue;
                    }
                }
                if (!attributeFound) {
                    attributes.push({name: propName, value: propValue});
                }
            };
            const tagsUsecase = propValue => {
                that.attributes.tags = propValue;
            };
            const defaultUsecase = (propValue, propName) => {
                that.attributes.image[propName] = propValue;
            };
            const propSwitch = {
                originalUrl: saveUsecase,
                large16x9Url: saveUsecase,
                large36x25Url: saveUsecase,
                large1x1Url: saveUsecase,
                large21x9Url: saveUsecase,
                large3x1Url: saveUsecase,
                large3x4Url: saveUsecase,
                medium16x9Url: saveUsecase,
                medium36x25Url: saveUsecase,
                medium1x1Url: saveUsecase,
                medium21x9Url: saveUsecase,
                medium3x1Url: saveUsecase,
                medium3x4Url: saveUsecase,
                small16x9Url: saveUsecase,
                small36x25Url: saveUsecase,
                small1x1Url: saveUsecase,
                small21x9Url: saveUsecase,
                small3x1Url: saveUsecase,
                small3x4Url: saveUsecase,
                jumbo2x3Url: saveUsecase,
                large2x3Url: saveUsecase,
                medium2x3Url: saveUsecase,
                small2x3Url: saveUsecase,
                canvas: saveUsecase,
                edit: saveUsecase,
                save: saveUsecase,
                tags: tagsUsecase,
            };

            (propSwitch[_propertyName] ? propSwitch[_propertyName] : defaultUsecase)(_propertyValue, _propertyName);
        }

        if (typeof propertyValue === 'object' && propertyName !== 'tags') {
            Object.keys(propertyValue).forEach(function(key) {
                setValue(propertyValue[key].value, propertyValue[key].property);
            });
        } else {
            setValue(propertyValue, propertyName);
        }
    },
    getTags() {
        return this.getModelPropertyValue('tags');
    },
    setTags(tags) {
        this.attributes.tags = tags;

        return this;
    },
    addTags(tags) {
        if ($.isArray(tags)) {
            this.setModelPropertyValue(Object.keys(tags).map(key => tags[key]), 'tags');
        }
        return this;
    },
    addTag(tag) {
        this.attributes.tags.push(tag);
        return this;
    },
    removeTags(tags) {
        if (tags instanceof Array) {
            tags.forEach(tag => this.removeTag(tag));
        }
        return this;
    },
    removeTag(tag) {
        this.attributes.tags = this.attributes.tags.filter(_tag => tag !== _tag);
        return this;
    },
});
export default ImageModel;
